<template>
    <common-page>
        <div class="bg-cover w-100 d-flex flex-column">
            <div class="w-100 h-auto position-relative">
                <b-img :src="require('../../../../assets/images/ppe/ppe_safety_officer_sign.png')" fluid
                       class="w-100"></b-img>
                <div class="title-cover"></div>
            </div>
            <h2 class="title">PPE领用申请</h2>
            <div class="card d-flex flex-column ml-2 mr-2 mb-2 p-3">
                <h4 class="card-label">
                    操作入口
                </h4>
                <div class="d-flex flex-row">
                    <div class="col-4 d-flex flex-column">
                        <div class="icon-cover" style="background-color: #ffffff">
                            <el-button class="share-button" icon="el-icon-edit" type="primary"
                                       style="margin-top: 10px;" @click="toNew"></el-button>
                        </div>
                        <div>发起</div>
                    </div>
                    <div class="col-4 d-flex flex-column">
                        <div class="icon-cover" style="background-color: #ffffff">
                            <el-badge :value="todoTaskCount" class="item-badge">
                                <el-button class="share-button" icon="el-icon-message-solid" type="warning"
                                           @click="gotoTodoList"></el-button>
                            </el-badge>
                        </div>
                        <div>待办</div>
                    </div>
                    <div class="col-4 d-flex flex-column">
                        <div class="icon-cover" style="background-color: #ffffff">
                            <el-badge :value="waitTaskCount" class="item-badge">
                                <el-button class="share-button" icon="el-icon-alarm-clock" type="success"
                                           @click="gotoWaitList"></el-button>
                            </el-badge>
                        </div>
                        <div>等待</div>
                    </div>
                </div>
            </div>

            <div class="card d-flex flex-column ml-2 mr-2 mb-2 p-3">
                <h4 class="card-label">
                    PPE领用申请规则
                </h4>
                <div class="d-flex flex-row">
                    <div class="d-flex flex-column" @click="toNew">
                        <div class="text-cover" style="background-color: #ffffff">
                            PPE是公司为保证员工工作安全而提供的劳动保护用品。PPE的领用实行解决，按需领用的原则。工作鞋和工作服需要以旧换新。
                            旧的物品为上次领用的物品。<br>
                            如您工作中为保证安全确实需要，请填写申请单，发起PPE领用申请。经过部门主管/经理审批，EHS部门审批后，方可发放。
                        </div>
                    </div>
                </div>
            </div>
            <div class="card d-flex flex-column ml-2 mr-2 mb-2 p-3">
                <div class="d-flex flex-row">
                    <div class="d-flex flex-column" @click="toNew">
                        <div style="background-color: #ffffff">
                            <b-img :src="require('../../../../assets/images/ppe/ppe_sample.png')" fluid
                                   class="w-100"></b-img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "HazardHome",
    components: {CommonPage},
    mixins: [emCommonListMixin, emCommonApiMixin],
    data() {
        return {
            todoTaskCount: null,
            waitTaskCount: null,
        }
    },
    mounted() {
        this.getTaskCount();
    },
    methods: {
        toNew() {
            this.$router.push("/em/ppe/apply");
        },
        gotoTodoList() {
            this.$router.push("/em/ppe/ppeApplyRecordList?pathType=todo");
        },
        gotoWaitList() {
            this.$router.push("/em/ppe/ppeApplyRecordList?pathType=wait");
        },
        getTaskCount() {
            this.$store.dispatch("api/post", {
                url: this.$store.state.ppeApplyRecord.baseModuleUrl + '/ppeApplyRecord/getTodoAndWaitCount',
                data: {}
            }).then(res => {
                this.todoTaskCount = res.data.todoCount;
                this.waitTaskCount = res.data.waitCount;
            });
        },
    }
}
</script>

<style scoped>
.bg-cover {
    background-color: #521772;
    overflow-y: auto;
}

.title-cover {
    width: 100%;
    height: 70px;
    font-weight: bold;
    position: absolute;
    bottom: -1px;
    background-image: linear-gradient(rgba(82, 23, 114, 0), #521772)
}

.title {
    margin: .25rem auto;
    color: white;
}

h3 {
    font-size: 1.5rem;
}

h4 {
    font-size: .9rem;
}

.card-label {
    margin-bottom: .8rem;
}

.label-cover {
    margin: .3rem auto auto auto;
}

.icon-cover {
    width: 55px;
    height: 55px;
    margin: auto;
    display: flex;
    border-radius: 5px;
}

.icon-cover i {
    font-size: 1.8rem;
    color: white;
    margin: auto;
}

.icon-cover ~ div {
    margin: .4rem auto auto auto;
}

.text-cover {
    width: 100%;
    height: 75px;
    font-size: 0.9rem;
    margin: auto;
    display: flex;
    border-radius: 5px;
}

.item-badge {
    margin-top: 10px;
    margin-right: 40px;
}

.share-button {
    width: 3.5rem;
    height: 3rem;
}
</style>
